<template>
  <div class="tab-pane" :class="{ active: defaultTab, show: defaultTab }" :id="id">
    <div class="p-4 b-b _600 nav-title">Rubric Builder</div>
    <div class="row m-0">
      <div class="px-4 pt-4 col-sm-12">
        <div class="form-group">
          <div class="text-center h2">{{item.rubric.name}}</div>
        </div>
        <div class="px-4 pt-4">
          <table class="table mb-0">
            <thead>
              <tr>
                <th>Name</th>
                <th>Min</th>
                <th>Max</th>
                <th>-</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(trait,index) in item.rubric.traits" v-bind:key="index">
                <template v-if="trait.min != trait.max">
                  <td>{{trait.name}} <small v-if="trait.description" v-html="trait.description" class="form-text text-muted"></small></td>
                  <td>{{trait.min}}</td>
                  <td>{{trait.max}}</td>
                  <td>
                    <button
                      v-if="!trait.separator"
                      @click="editSPDs(trait)"
                      data-toggle="modal"
                      data-target="#spdEditModal"
                      class="btn btn-sm btn-icon btn-rounded theme-accent text-white m-0"
                      v-tippy
                      title="Score Point Descriptors"
                    >
                      <i class="fa fa-comment-alt-lines" style="font-size: 0.9rem;"></i>
                    </button>
                  </td>
                  <td>
                    <input v-model="trait.keep" type="checkbox" class="clCheckbox" />
                    <i class="theme"></i>
                  </td>
                </template>
                <template v-if="trait.min ==trait.max">
                  <td colspan="6" class="trait-title">{{trait.name}}</td>
                </template>
                
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- Score Point Desciptor Edit Modal -->
    <div class="modal" id="spdEditModal" data-backdrop="static" data-keyboard="false">
      <div v-if="editingSPDTrait" class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5>
              Score Point Descriptors -
              <strong>{{ editingSPDTrait.name }}</strong>
            </h5>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <table class="table">
                  <thead>
                    <tr>
                      <th style="width: 60px;">Score Point</th>
                      <th>Descriptor</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="sp in editingSPDTrait.score_point_descriptors"
                      :key="`${sp.sequence}`"
                    >
                      <td class="v-mid text-center">
                        <h3>{{ sp.val >= 0 ? sp.val : sp.code }}</h3>
                      </td>
                      <td>
                        <RichText
                          :text.sync="sp.desc"
                          :initial="sp.init_desc"
                          :options="{ height: 104 }"
                          integrated
                          :refresh="editingSPDTrait.id"
                        ></RichText>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button class="btn btn-flat" data-dismiss="modal">Done</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.invalid {
  color: red;
}
.v-select-apply .dropdown-toggle {
  border-radius: 0px;
  /* should work but doesn't :( */
}
.anim-rotate {
  transition: transform 0.3s ease-out;
}
.rotate-180 {
  transform: rotate(180deg);
}
button {
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Create a custom checkbox */
.clCheckbox {
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  border: solid;
}

.trait-title {
  font-size: 20px;
  text-align: center;
  font-weight: bold;
  background-color: rgb(224, 229, 232);
}
</style>

<script>
import RubricService from "@/services/RubricService";
import ItemService from "@/services/ItemService";
import notie from "@/services/NotieService";
import RichText from "@/components/RichText";
import ConfigService from "@/services/ConfigService";

import PercentInput from "@/components/PercentInput";
import ConfigSelect from "@/components/ConfigSelect";
import Rubric from "@/components/Rubric";
import Utils from "@/services/Utils";

export default {
  name: "RubricPicker",

  props: [
    "id",
    "item",
    "dirty",
    "defaultTab",
    "validationHints",
    "valid",
    "template"
  ],

  components: { PercentInput, ConfigSelect, Rubric,RichText },

  data() {
    return {
      rubrics: [],
      user: this.$route.meta.user,
      editingSPDTrait:null,
      isScored: false,
      item_types: [
        {
          id: "SINGLE",
          name: "Single Scored"
        },
        {
          id: "DOUBLE_ONLY",
          name: "Double Scored No Resolution"
        },
        {
          id: "DOUBLE_EXACT",
          name: "Double Scored Exact"
        },
        {
          id: "DOUBLE_EXACT_ADJACENT",
          name: "Double Scored Exact/Adjacent"
        },
        {
          id: "DOUBLE_WEIGHTED",
          name: "Double Scored Weighted Range"
        },
        {
          id: "OMAHA",
          name: "Omaha Scoring Rule"
        }
      ],
      simRubric: {
        show: false,
        leftScore: {},
        leftComplete: null,
        rightScore: {},
        rightComplete: null,
        leftWeight: null,
        rightWeight: null,
        needsRes: null,
        leftLoading: false,
        rightLoading: false,
        resLoading: false,
        leftReset: 0,
        rightReset: 0
      },
      standards : [],
      assessments: null
    };
  },

  created() {
    // add standards section
        let found = this.item.rubric.traits.find(x => x.name === "Standards Rubric")
        if(found == null && this.user.client.standards_rubric == true){
          this.item.rubric.traits.push({
          name: "Standards Rubric",
          id: Utils.generateUUID(),
          sequence: this.item.rubric.traits.length + 1,
          min: 0,
          max: 0,
          weight: 1,
          separator: true,
          condition_codes: [],
          score_point_codes: [],
          score_point_descriptors: [],
          masked_score_points: []
        });
        }

    this.loadStandards()
  },

  computed: {},

  watch: {		
    "item.standards"() {
      this.addStandardRubrics()
      console.log("standards changed",this.item.rubric)
    }
    },

  methods: {
    addStandardRubrics(){
      if(this.user.client.standards_rubric != true){
        return 
      }
      this.item.standards.forEach(element => {
        
        let found = this.item.rubric.traits.find(x => x.name === element)
        let standard = this.standards.find(x => x.name === element)

        if(found == null ){
          this.item.rubric.traits.push({
          name: element,
          description:standard.description,
          id: Utils.generateUUID(),
          sequence: this.item.rubric.traits.length + 1,
          min: this.item.rubric.standard_rubric_min,
          max: this.item.rubric.standard_rubric_max,
          weight: 1,
          separator: false,
          condition_codes: [],
          score_point_codes: [],
          score_point_descriptors: [],
          masked_score_points: []
        });   
        console.log("pushing.. ",this.item.rubric.traits)
        }
        else {
          console.log(" Standard trait is already added")
        }

      });
      

    },
    loadStandards() {
      ConfigService.getStandards()
        .then(resp => {
          console.log(" LOADING STANDARDS IN RUBRIC PICKER")
          this.standards = resp.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    editSPDs(trait) {
      this.setupDescriptors(trait);
      this.editingSPDTrait = trait;
    },
    setupDescriptors(trait) {
      var seq = 0;

      var step = 1;
      if (trait.use_half_points) {
        step = 0.5;
      }
      if (!trait.score_point_descriptors) {
        this.$set(trait, "score_point_descriptors", []);
      }
      var min = trait.min;
      var max = trait.max;

      var skip = trait.masked_score_points.map(function(mask) {
        return mask.mask_value;
      });

      if (this.item.rubric.reverse_score_points) {
        for (var i = max; i >= min; i -= step) {
          if (_.includes(skip, i)) {
            continue;
          }
          let existing = _.find(trait.score_point_descriptors, {
            val: i
          });
          if (existing) {
            existing.sequence = seq;
            existing.init_desc = existing.desc;
            existing.keep = true;
          } else {
            trait.score_point_descriptors.push({
              val: i,
              desc: "",
              init_desc: "",
              sequence: seq,
              keep: true
            });
          }
          seq++;
        }
      } else {
        for (var i = min; i <= max; i += step) {
          if (_.includes(skip, i)) {
            continue;
          }
          let existing = _.find(trait.score_point_descriptors, {
            val: i
          });
          if (existing) {
            existing.sequence = seq;
            existing.init_desc = existing.desc;
            existing.keep = true;
          } else {
            trait.score_point_descriptors.push({
              val: i,
              desc: "",
              init_desc: "",
              sequence: seq,
              keep: true
            });
          }
          seq++;
        }
      }

      trait.score_point_descriptors = _.sortBy(
        trait.score_point_descriptors,
        "sequence"
      );

      _.each(trait.condition_codes, cc => {
        let existing = _.find(trait.score_point_descriptors, {
          code: cc.symbol
        });
        if (existing) {
          existing.sequence = seq;
          existing.init_desc = existing.desc;
          existing.keep = true;
        } else {
          trait.score_point_descriptors.push({
            val: -1,
            code: cc.symbol,
            desc: "",
            init_desc: "",
            sequence: seq,
            keep: true
          });
        }
        seq++;
      });

      trait.score_point_descriptors = _.filter(trait.score_point_descriptors, {
        keep: true
      });
      _.each(trait.score_point_descriptors, spd => {
        delete spd.keep;
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/assessment/RubricPicker.vue